/* globals siteurl */
import './voucherCode';
import './paypalButton';

export const updateCosts = function (data) {
  $.each(data.results, (rowid, item) => {
    $(`.js-item-price-${item.rowid}`).html(item.price_no_discount);
  });
  if (data.delivery_times) {
    $('#delivery-times').html(data.delivery_times);
  }
  $('.js-subtotal-value').html(data.total_no_discount);
  $('.js-discount-value').html(`-${data.discount_value}`);
  $('#shipping-cost').html(data.shipping_costs);
  $('#total').html(data.total);
};

export const refreshCart = function () {
  $.post(
    `${siteurl}ajax/refresh_cart`,
    {},
    (data) => {
      updateCosts(data);
    },
    'json',
  );
};

window.initiateCheckoutTracked = false;

window.trackInitiateCheckout = function () {
  if (window.initiateCheckoutTracked) {
    return;
  }
  console.log('fbq initiate checkout');

  window.initiateCheckoutTracked = true;

  if (typeof fbq === 'function') {
    const totalText = $('#total').text()
      .replace(/[^\d,.-]/g, '')
      .trim();

    const value = totalText.includes(',') && totalText.includes('.')
      ? parseFloat(totalText.replace(/\./g, '').replace(',', '.'))
      : parseFloat(totalText.replace(',', '.'));

    fbq('track', 'InitiateCheckout', {
      value: value,
      currency: window.current_currency || 'EUR'
    });
  }
};

const setShippingCosts = function (countryId) {
  $.post(
    `${siteurl}ajax/set_shipping_costs`,
    { country_id: countryId },
    (data) => {
      updateCosts(data);
    },
    'json',
  );
};
const updateRowQuantity = function () {
  const rowid = $(this).data('rowid');
  const quantity = $(this).val();
  var action = $.post(
    //`${siteurl}/ajax/change_quantity_cart_item`,
    `${siteurl}ajax/cart/item/update-quantity`,
    { rowid, quantity },
    (data) => {
      updateCosts(data);
    }, 'json',
  );

  action.done(function (data) {
    if (data == 'ok')
      location.reload();
    else if (data.status == 'not_enough_calendars') {
      alert("We have only " + data.max_quantity + " units left for this calendar.");
      location.reload();
    }
  });
};
const deleteRow = function () {
  const rowid = $(this).data('rowid');
  var action = $.post(
    //`${siteurl}ajax/delete_cart_item`,
    `${siteurl}ajax/cart/item/delete`,
    { rowid },
    (data) => {
      location.reload();

      $(`#${rowid}`).hide('fast');
      updateCosts(data);
      $('.cart-quantity').html(data.cart_quantity);

      if (data.cart_quantity == 0) {
        $('.cart').hide();
        $('#total-line').hide();
        $('#code-form').hide();
        $('.cart-next').hide();
        $('#cart-empty-message').show();
      }
    },
    'json',
  );
  action.done(function () {
    location.reload();
  });
};

$('.js-cart-next').on('click', function () {
  window.trackInitiateCheckout();
});

$('.js-quantity').change(updateRowQuantity);
$('.js-cart-row-delete').click(deleteRow);


$('option.region_not_for_calendars').attr('disabled', 'disabled');


$('.js-delivery-country').change(function () {
  const selected = $(this).find(':selected');
  const countryId = selected.val();
  const region = selected.data('region');
  const action = $.post(
    //`${siteurl}ajax/on_delivery_country_change`,
    `${siteurl}ajax/cart/shipping/country`,
    { countryId, region },
    (data) => {
      updateCosts(data);
    },
    'json',
  );
  action.done(() => {
    window.location.reload();
  });
});


$(".use-express-delivery").change(function () {

  let value = $(this).prop('checked');
  console.log(value);
  const action = $.post(
    `${siteurl}ajax/cart/shipping/express-delivery`,
    { value },
    (data) => {
      updateCosts(data);
    },
    'json',
  );
  action.done(() => {
    window.location.reload();
  });
})
const setExpressDeliveryCountdown = function () {
  if ($(".countdown").length == 0)
    return;

  var countDownDate = new Date($(".countdown").data('deadline')).getTime();

  // Update the count down every 1 second
  var x = setInterval(function () {

    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result in the element with id="demo"
    $(".countdown").html(hours + ":" + minutes + ":" + seconds + "h");

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(x);
      $(".countdown").html('ABGELAUFEN');
    }
  }, 1000);
}
setExpressDeliveryCountdown();

/*

const loggedIn = $('#is_logged_in').val();
if (loggedIn == 1) {
  $('#order-form').validate({
    rules: {
      payment_user_gender: 'required',
      payment_first_name: 'required',
      payment_last_name: 'required',
      payment_country: 'required',
      payment_address: 'required',
      payment_postal_code: 'required',
      payment_city: 'required',
      email: {
        required: true,
        email: true,
      },
      accept_terms_and_conditions: 'required',
    },
    errorPlacement(label, element) {
      if (element.attr('name') === 'accept_terms_and_conditions') {
        element.parent().append(label);
      } else {
        label.insertAfter(element);
      }
    },
    onfocusout: false,
    onkeyup: false,
    submitHandler(form) {
      form.submit();
    },
  });
} else {
  $('#order-form').validate({
    rules: {
      payment_user_gender: 'required',
      payment_first_name: 'required',
      payment_last_name: 'required',
      payment_country: 'required',
      payment_address: 'required',
      payment_postal_code: 'required',
      payment_city: 'required',
      email: {
        required: true,
        email: true,
      },
      cart_password: {
        required: true,
        minlength: 6,
      },
      confirm_password: {
        required: true,
        minlength: 6,
        equalTo: '#cart_password',
      },
      accept_terms_and_conditions: 'required',
    },
    errorPlacement(label, element) {
      if (element.attr('name') === 'accept_terms_and_conditions') {
        element.parent().append(label);
      } else {
        label.insertAfter(element);
      }
    },
    onfocusout: false,
    onkeyup: false,
  });
}
*/
